import React, { useEffect, useState } from 'react'
import cn from 'classnames'

import useIsMobile from '../../useIsMobile'
import SideNav from '../../../_SideNav'

import Navigation from '../Navigation'
import SideNavbar from '../SideNavbar'

import './index.scss'

function SidebarPanel({
  showSidebar,
  headerList,
  sidebarList,
  title,
  actions,
  searchLabel,
  searchPlaceholder,
  showSidebarSearch,
  isSideNavExpanded,
  onClickSideNavExpand,
  onNavigate,
  titleLink,
  location,
  enableDragAndDrop,
  getMapModelByDragAndDrop
}) {
  const isMobile = useIsMobile()
  const [sidebarSectionExpanded, setSidebarSectionExpanded] = useState(null)

  // quando si va in mobile di default la sidenav è chiusa
  useEffect(() => {
    isMobile && onClickSideNavExpand()
  }, [isMobile])


  if (isMobile || showSidebar) {
    return (
      <SideNav
        className={cn('ublique-sidebar-panel', {
          'is-mobile': isMobile
        })}
        aria-label='Side Navigation'
        expanded={isSideNavExpanded}
      >
        {isMobile && (
          <Navigation
            fill
            items={headerList}
            type='sidebar'
            onNavigate={onNavigate}
            isSideNavExpanded={isSideNavExpanded}
            onClickSideNavExpand={onClickSideNavExpand}
            sidebarSectionExpanded={sidebarSectionExpanded}
            setSidebarSectionExpanded={setSidebarSectionExpanded}
          />
        )}
        {showSidebar && (
          <SideNavbar
            title={title}
            actions={actions}
            showHeader={!isMobile}
            sidebarList={sidebarList}
            isSideNavExpanded={isSideNavExpanded}
            showSidebarSearch={showSidebarSearch}
            onClickSideNavExpand={onClickSideNavExpand}
            searchLabel={searchLabel}
            titleLink={titleLink}
            searchPlaceholder={searchPlaceholder}
            sidebarSectionExpanded={sidebarSectionExpanded}
            setSidebarSectionExpanded={setSidebarSectionExpanded}
            location={location}
            enableDragAndDrop={enableDragAndDrop}
            getMapModelByDragAndDrop={getMapModelByDragAndDrop}
          />
        )}
      </SideNav>
    )
  }

  return null
}

export default React.memo(SidebarPanel)
